import { WACallStates, WACallStatus } from './interface';

export const getTabId = (): string => {
  let tabId = sessionStorage.getItem('WA_TAB_ID');
  if (!tabId) {
    tabId = `${Date.now()}_${Math.random().toString(36).slice(2, 8)}`;
    sessionStorage.setItem('WA_TAB_ID', tabId);
  }
  return tabId;
};

export const HEARTBEAT_STALE_MS = 30_000;

export const BLOCKING_STATUSES: WACallStatus[] = [
  WACallStates.CHECKING_LOGIN,
  WACallStates.NEEDS_TAB_SHARE,
  WACallStates.SETTING_UP,
  WACallStates.IN_PROGRESS,
  WACallStates.CONNECTED,
  WACallStates.UPLOADING
];

export const isBlockingStatus = (status: WACallStatus): boolean =>
  BLOCKING_STATUSES.includes(status);

// States where a call is actively being set up or is in progress with the customer.
export const CROSS_TAB_ACTIVE_STATUSES: WACallStatus[] = [
  WACallStates.SETTING_UP,
  WACallStates.IN_PROGRESS,
  WACallStates.CONNECTED,
  WACallStates.UPLOADING
];

export const isCrossTabActiveStatus = (status: WACallStatus): boolean =>
  CROSS_TAB_ACTIVE_STATUSES.includes(status);

export const checkIsNumberMasked = (number: string): boolean => {
  if (!number?.trim()) return false;
  const cleaned = number.replace(/[^0-9xX]/g, '');
  return /^[0-9]+[xX]+[0-9]+$/.test(cleaned); //1 or more X showcasing numbeer is masked
};
